// ----------------------------------------------------------------------

/**
 * @description
 * MuiTooltip overrides
 * @param {Object} theme - The theme object
 * @returns {Object} MuiTooltip overrides
 */
export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[800],
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}
